import React, { useEffect, useState, lazy } from 'react';
import { ShieldCheck } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Checkout() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 50);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 14 * 60 + 50);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <section id="checkout" className="py-4 md:py-20 px-3 md:px-4 bg-white scroll-mt-2" data-id="element-36">
      <div className="max-w-3xl mx-auto text-center" data-id="element-37">
        <div className="bg-red-50 border border-red-200 rounded-full px-3 md:px-6 py-1 md:py-2 inline-flex items-center gap-2 mb-3 md:mb-8" data-id="element-38">
          <span className="relative flex h-2.5 w-2.5 md:h-3 md:w-3" data-id="element-39">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-40"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 md:h-3 md:w-3 bg-red-500" data-id="element-41"></span>
          </span>
          <span className="text-red-600 font-bold tracking-widest text-xs md:text-base" data-id="element-42">
            EXPIRA EN: {formatTime(timeLeft)}
          </span>
        </div>

        <div className="bg-[#EFE4CC] border-2 border-teal-500/50 rounded-2xl md:rounded-3xl p-3 md:p-10 shadow-2xl relative overflow-hidden" data-id="element-43">
          <div className="absolute top-0 inset-x-0 h-1 bg-gradient-to-r from-transparent via-teal-500 to-transparent" data-id="element-44"></div>

          <h2 className="text-xl md:text-4xl font-extrabold text-slate-900 mb-1 md:mb-2" data-id="element-45">
            Elegí tu acceso
          </h2>
          <p className="text-[11px] md:text-base text-slate-600 mb-3 md:mb-8" data-id="element-46">
            Tu compra incluye los 4 bonos exclusivos de hoy
          </p>

          {/* Product selection card */}
          <a href="https://mentecheck.librosdigitales.pro/cart/46849998749835:1" className="block mb-3 md:mb-8 text-left group" data-id="element-47">
            <div className="bg-white border-2 border-teal-500 rounded-xl md:rounded-2xl p-3 md:p-6 shadow-lg hover:shadow-xl transition-all relative" data-id="element-48">
              {/* Selected badge */}
              <div className="absolute -top-2.5 left-4 md:-top-3 md:left-6 bg-teal-600 text-white text-[10px] md:text-xs font-bold px-2 md:px-3 py-0.5 md:py-1 rounded-full tracking-wide" data-id="element-49">
                ✓ SELECCIONADO
              </div>

              <div className="flex items-center gap-2 md:gap-4" data-id="element-50">
                {/* Radio indicator */}
                <div className="shrink-0 w-5 h-5 md:w-6 md:h-6 rounded-full border-2 border-teal-600 flex items-center justify-center bg-white" data-id="element-51">
                  <div className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-teal-600" data-id="element-52"></div>
                </div>

                {/* Product info */}
                <div className="flex-1 min-w-0" data-id="element-53">
                  <div className="flex items-center gap-1.5 md:gap-2 mb-0.5 md:mb-1" data-id="element-54">
                    <span className="text-base md:text-xl" data-id="element-55">📘</span>
                    <h3 className="text-sm md:text-xl font-extrabold text-slate-900 truncate" data-id="element-56">
                      MENTE ACTIVA
                    </h3>
                  </div>
                  <p className="text-[10px] md:text-sm text-slate-600 leading-tight md:leading-snug" data-id="element-57">
                    6 Tomos + 4 Bonos · 48 fichas · Sistema completo
                  </p>
                </div>

                {/* Price */}
                <div className="shrink-0 text-right" data-id="element-58">
                  <p className="text-[10px] md:text-xs text-slate-400 line-through leading-none mb-0.5 md:mb-1" data-id="element-59">
                    $49.900
                  </p>
                  <p className="text-base md:text-2xl font-black text-teal-700 leading-none" data-id="element-60">
                    $19.990
                  </p>
                  <p className="text-[9px] md:text-[10px] text-slate-500 mt-0.5 md:mt-1" data-id="element-61">
                    ARS
                  </p>
                </div>
              </div>
            </div>
          </a>

          <div className="mb-3 md:mb-8" data-id="element-62">
            <p className="text-teal-700 font-medium text-[11px] md:text-base" data-id="element-63">
              Pago único — Acceso inmediato de por vida
            </p>
          </div>

          <div className="space-y-2 md:space-y-6" data-id="element-64">
            <CTAButton text="SÍ, QUIERO MENTE ACTIVA →" isMain={true} className="!w-full !py-3 !text-base md:!py-5 md:!text-xl" data-id="element-65" />

            <a href="https://mentecheck.librosdigitales.pro/cart/46849998749835:1" className="block w-full -mt-2 md:-mt-5" data-id="element-66">
              <img src="https://cdn.magicpatterns.com/uploads/tZbaQPtNC24bXgJ7Jj36WR/imagen.png" alt="Pago seguro con Mercado Pago" loading="lazy" className="w-full h-auto cursor-pointer hover:scale-[1.02] transition-transform duration-300" data-id="element-67" />
            </a>

            <div className="flex flex-col items-center gap-1.5 md:gap-3 text-xs md:text-sm text-slate-600" data-id="element-68">
              <div className="flex items-center gap-1.5 md:gap-2 text-green-700 bg-green-100 px-3 md:px-4 py-1 md:py-2 rounded-full" data-id="element-69">
                <ShieldCheck className="w-4 h-4 md:w-5 md:h-5" data-id="element-70" />
                <span className="font-medium text-[11px] md:text-sm" data-id="element-71">
                  Pago 100% seguro
                </span>
              </div>
              <p className="text-[10px] md:text-sm" data-id="element-72">
                Descarga inmediata en PDF · Acceso de por vida
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}